export const miniModalDialogPreset = {
    name: 'mwMiniModal',
    methods: [
        'title',
        'htmlContent',
        'textContent',
        'content',
        'ok',
        'cancel',
        'wide',
        'noPadding',
        'class',
        'isOkEnabled'
    ],

    // mdDialogProvider expects options to be a function that returns the options object
    options: () => {
        'ngInject';
        return {
            autoWrap: false,
            controllerAs: '$ctrl',
            bindToController: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: true,
            multiple: true,
            template: `
                <md-dialog class="mw-mini-modal" ng-class="[$ctrl.class, {'mw-mini-modal--wide':$ctrl.wide}]" aria-label="" layout="column">
                    <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.title}}" ok="{{$ctrl.ok}}" cancel="{{$ctrl.cancel}}" no-padding="$ctrl.noPadding" is-ok-enabled="$ctrl.isOkEnabled" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">
                        <mw-modal-content>
                            <div ng-if="::$ctrl.mdHtmlContent" class="md-dialog-content-body" ng-bind-html="::$ctrl.mdHtmlContent"></div>
                            <div ng-if="::!$ctrl.mdHtmlContent" class="md-dialog-content-body">
                                <p class="mw-mini-modal__text-content">{{::$ctrl.mdTextContent}}</p>
                            </div>
                        </mw-modal-content>
                    </mw-mini-modal-dialog>
                </md-dialog>
            `,
            controller: class MiniModalDialog {
                constructor (private $mdDialog) {
                    'ngInject';
                }

                handleOk(event) {
                    this.$mdDialog.hide(true);
                };

                handleCancel(event) {
                    this.$mdDialog.cancel();
                };
            }
      }
    }
}




// WEBPACK FOOTER //
// ./src/lib/components/dialog/mini-modal/mini-modal.dialog.preset.ts